import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faCheck } from "@fortawesome/pro-light-svg-icons"
import { DocumentoComercialValidacionDtoProps } from "api/DTOs/DocumentoComercialValidacionDto"
import CircularSignStatus from "features/Validaciones/components/CircularSignsStatus"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { LABEL_APROBAR_DOCUMENT } from "../constant"

export const APROBAR_DOCUMENTOS_COLUMNS = (
  t: TFunction,
  handleRedirectToDetail: (
    rowData: DocumentoComercialValidacionDtoProps[]
  ) => void,
  tabSelected: number
) => {
  const columns = [
    {
      key: "serie",
      header: `${t("documentos.validar.tab.headerNum")}`,
      field: "serie",
      body: (rowData: DocumentoComercialValidacionDtoProps) =>
        rowData?.serie?.length === 1 && rowData?.numero
          ? `${rowData?.serie}${rowData?.numero?.toString().padStart(4, "0")}`
          : rowData?.serie,
      className: "tw-text-base tw-text-text",
    },
    {
      key: "razonSocialLibrador",
      header: `${t("documentos.validar.tab.headerCompanyName")}`,
      field: "razonSocialLibrador",
    },
    {
      key: "nifLibrador",
      header: `${t("documentos.validar.tab.headerNif")}`,
      field: "nifLibrador",
    },
    {
      key: "importe",
      header: `${t("documentos.validar.tab.headerTax")}`,
      field: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({ importe }: DocumentoComercialValidacionDtoProps) =>
        frontendCurrency(importe ?? 0),
    },

    {
      key: "fechaEmision",
      header: `${t("documentos.validar.tab.headerDateEmision")}`,
      field: "fechaEmision",
      body: ({ fechaEmision }: DocumentoComercialValidacionDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
    },
    {
      key: "firmas",
      style: { width: "4%" },
      header: `${t("documentos.validar.tab.headerSignatures")}`,
      field: "firmas",
      body: (rowData: DocumentoComercialValidacionDtoProps) =>
        CircularSignStatus(rowData),
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: DocumentoComercialValidacionDtoProps) => {
        if (!rowData.id) return
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: LABEL_APROBAR_DOCUMENT(t, tabSelected),
                hasRedirect: true,
                action: () => {
                  rowData?.id && handleRedirectToDetail([rowData])
                },
                icon: faCheck,
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
